import type { IconType } from "react-icons";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";

export type SocialPlatform =
  | "facebook"
  | "twitter"
  | "instagram"
  | "linkedin"
  | "youtube";

export interface SocialLink {
  platform: SocialPlatform;
  href: string;
  label: string;
}

const SOCIAL_ENV_KEYS: Record<SocialPlatform, string> = {
  facebook: "NEXT_PUBLIC_SOCIAL_FACEBOOK",
  twitter: "NEXT_PUBLIC_SOCIAL_TWITTER",
  instagram: "NEXT_PUBLIC_SOCIAL_INSTAGRAM",
  linkedin: "NEXT_PUBLIC_SOCIAL_LINKEDIN",
  youtube: "NEXT_PUBLIC_SOCIAL_YOUTUBE",
};

const SOCIAL_LABELS: Record<SocialPlatform, string> = {
  facebook: "Facebook",
  twitter: "Twitter",
  instagram: "Instagram",
  linkedin: "LinkedIn",
  youtube: "YouTube",
};

export const SOCIAL_ICONS: Record<SocialPlatform, IconType> = {
  facebook: FaFacebookF,
  twitter: FaTwitter,
  instagram: FaInstagram,
  linkedin: FaLinkedinIn,
  youtube: FaYoutube,
};

function isSafeHttpsUrl(value: string): boolean {
  try {
    const url = new URL(value);
    return url.protocol === "https:";
  } catch {
    return false;
  }
}

function readSocialUrl(platform: SocialPlatform): string {
  const key = SOCIAL_ENV_KEYS[platform];
  const raw = process.env[key]?.trim() ?? "";
  return isSafeHttpsUrl(raw) ? raw : "";
}

/** Social URLs from NEXT_PUBLIC_SOCIAL_* env vars (empty URLs omitted). */
export function getSocialLinks(): SocialLink[] {
  return (Object.keys(SOCIAL_ENV_KEYS) as SocialPlatform[])
    .map((platform) => ({
      platform,
      href: readSocialUrl(platform),
      label: SOCIAL_LABELS[platform],
    }))
    .filter((link) => link.href.length > 0);
}

export function getSocialSameAs(): string[] {
  return getSocialLinks().map((link) => link.href);
}
